// src/plugins/vuetify.js
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { VApp, VAppBar, VBtn, VIcon, VMenu, VToolbarTitle, VList, VListItem, VListItemTitle,VTextField,
  VTextarea,
  VSelect, } from 'vuetify/components';

export default createVuetify({
  components: {
    VApp,
    VAppBar,
    VBtn,
    VIcon,
    VMenu,
    VToolbarTitle,
    VList,
    VListItem,
    VListItemTitle,
    VTextField,
    VTextarea,
    VSelect,

    
  }
});
